<template>
    <div class="pg-index">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide swiper-slide-big swiper-slide-big-home">
                    <div class="content content_home">
                        <div class="header">
                          <img src="./images/mHome/logo.png">
                          <div class="main_title">
                            征途2手游
                            <div class="sub_title">官方正版手游</div>
                          </div>
                          <a href="https://zt2m.ztgame.com/" class="btnsom">进入官网</a>
                          <a :href="downloadUrl" class="btnsom">下载游戏</a>
                        </div>
                        <div class="human fadeIn animated"></div>
                        <div class="slogan zoomIn animated"></div>
                        <div class="indicator" @click="slideNext"></div>
                    </div>
                </div>
                <div class="swiper-slide swiper-slide-big">
                    <div class="content content_1">
                        <div class="moon"></div>
                        <div class="title"></div>
                        <div class="feature_5 animated">
                          在线时长最长的玩家已经有<span class="emphasis">7271h</span>的在线时间！勇士要 好好吃饭睡觉呀!有几位勇士已经突破<span class="emphasis">10000000+</span>战力 了！膜拜大佬~
                        </div>
                        <div class="feature_4 animated">
                            勇士总击杀达到了<span class="emphasis">512554848</span>次！<br>每秒就有<span class="emphasis">123821</span>人倒在王城的某个角落！
                        </div>
                        <div class="feature_3 animated">
                            一共有过<span class="emphasis">152637</span>个家族，在家族战中族员变为宝石搬运工的次数高达<span class="emphasis">2716283</span>次~！
                        </div>
                        <div class="feature_2 animated">
                            一共完成过<span class="emphasis">32830321</span>次三世情缘任务~女神们~<br>终有一天你的盖世英雄会带着同心结来娶你的~
                        </div>
                        <div class="feature_1 animated">
                            某位勤勤恳恳的勇士总击杀了<span class="emphasis">12382716</span>只野怪！ 有事没事砍小怪~经验到手稳稳的~
                        </div>
                        <div class="indicator indicator-1" @click="slideNext"></div>
                    </div>
                </div>
                <div class="swiper-slide swiper-slide-big swiper-slide-big-2">
                    <div class="content content_2">
                      <div class="moon"></div>
                      <div class="center">
                          <div class="center_1">
                            <div class="card fadeIn animated" :class="[`card_${index + 1}`]" v-for="(card, index) in cardList" :key="index">
                              <div class="card_inner" :class="[`card_inner_${card}`]"></div>
                            </div>
                          </div>
                          <div class="center_2"></div>
                          <div class="center_3"></div>
                          <div class="center_4"></div>
                          <div class="center_5"></div>
                      </div>
                      <div class="bottom"></div>
                      <div class="pray_container">
                          <div class="pray" @click="showCard"></div>
                          <div class="times">您还可以祈愿 <span class="emphasis">{{user_info.ga_account ? user_info.left_cnt : ''}}</span> 次</div>
                          <div class="account">
                            <div class="name">{{user_info.ga_account}}</div>
                            <div class="text_btn" @click="changeAccount">{{user_info.ga_account ? '更换账号' : '登录'}}</div>
                          </div>
                      </div>
                      <div class="pray_times">总祈愿次数：<span style="color: red">{{index_data.total_pray_cnt}}</span></div>
                      <div class="gift_wrapper">
                          <div class="gift_container">
                            <div class="gift">
                                <div class="gift_bg"></div>
                            </div>
                            绑银*388
                          </div>
                          <div class="gift_container">
                            <div class="gift">
                                <div class="gift_bg gift_bg_2"></div>
                            </div>
                            月兔发饰(1天)*2
                          </div>
                          <div class="gift_container">
                            <div class="gift">
                                <div class="gift_bg gift_bg_3"></div>
                            </div>
                            中秋时装(1天)*2
                          </div>
                      </div>
                      <div class="slider_wrapper">
                          <div class="slider">
                              <div class="slider_inner"></div>
                              <div class="milestone milestone_1">
                                  <div class="milestone_inner"></div>
                              </div>
                              <div class="milestone milestone_2">
                                  <div class="milestone_inner"></div>
                              </div>
                              <div class="milestone milestone_3">
                                  <div class="milestone_inner"></div>
                              </div>
                          </div>
                          <div class="text_1">3999</div>
                          <div class="text_2">6999</div>
                          <div class="text_3">9999</div>
                      </div>
                      <div class="draw" @click="showCode">领取礼包</div>
                      <div class="title"></div>
                      <div class="btns">
                          <div class="btn" @click="showRule">活动说明</div>
                          <div class="btn" @click="showRecord">祈愿记录</div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import * as types from '~/store/mutation-type';
  import store from '~/store/index';
  import { mapState } from 'vuex';
  import { isAndroid, getParameterByName } from '~/tools/utils'
  import Swiper from 'swiper';
  import api from '~/api/api';

  export default {
    components: {
        // QuestionMobile
    },
    computed: {
        ...mapState({
            goToLogin: state => state.goToLogin,
        })
    },
    data () {
        return {
            callBackFn: '',
            needToRequestUserInfo: true,
            cardList: [],
            user_info: {},
            index_data: {},
            downloadUrl: `https://zt2m.ztgame.com/download/${isAndroid() ? 'android' : 'ios'}.html`
        }
    },
    mounted() {
      let _this = this;
      // store.commit(types.SHOW_ALERT, {msg: 'test', type: 'msg'});
      _this.swiper = new Swiper('.swiper-container', {
            direction: 'vertical',
            slidesPerView: 1,
            speed: 800,
            on: {
                init: function () {},
                transitionStart: function () {

                },
                transitionEnd: function () {
                    _this.initAnimation(this.slides.eq(0), '.slogan', 'zoomIn', 0, this.activeIndex, this.previousIndex);
                    _this.initAnimation(this.slides.eq(0), '.human', 'fadeIn', 0, this.activeIndex, this.previousIndex);
                    _this.initAnimation(this.slides.eq(1), '.feature_1', 'fadeIn', 1, this.activeIndex, this.previousIndex);
                    _this.initAnimation(this.slides.eq(1), '.feature_2', 'fadeIn', 1, this.activeIndex, this.previousIndex);
                    _this.initAnimation(this.slides.eq(1), '.feature_3', 'fadeIn', 1, this.activeIndex, this.previousIndex);
                    _this.initAnimation(this.slides.eq(1), '.feature_4', 'fadeIn', 1, this.activeIndex, this.previousIndex);
                    _this.initAnimation(this.slides.eq(1), '.feature_5', 'fadeIn', 1, this.activeIndex, this.previousIndex);
                    _this.initAnimation(this.slides.eq(1), '.moon', 'moon_ani', 1, this.activeIndex, this.previousIndex);
                    _this.initAnimation(this.slides.eq(2), '.moon', 'moon_up', 2, this.activeIndex, this.previousIndex);
                    if(_this.cardList.length) {
                      _this.cardList.forEach((item, index) => {
                        _this.initAnimation(this.slides.eq(2), `.card_${index + 1}`, 'fadeIn', 2, this.activeIndex, this.previousIndex);
                      });
                    }
                    _this.animSlider();
                },
            }
        });
      if(process.env.VUE_APP_ENV == 'development') {
        let res = {
          "status":1,
          "data":{
            user_info: {
              "login_status": 1,
              "ga_account":"瘋狂の怪獸™",
              "card_id_list": [1, 2, 3],
              "left_cnt": 0,
              "code_str": "009G9U9T"
            },
            index_data: {
              total_pray_cnt: 11134,
              pray_list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20]
            }
          }
        };
        this.user_info = Object.assign({}, res.data.user_info);
        this.index_data = Object.assign({}, res.data.index_data);
        this.updateMiniCards();
        store.commit(types.SHOW_LOADING, false);
      }
      if(getParameterByName('card')) {
        store.commit(types.SHOW_MODAL, {type: 'card', card_id: getParameterByName('card'), share: false});
        this.initData();
      } else if(process.env.VUE_APP_ENV !== 'development') {
        this.initData();
      }
      this.getInfo();
      // _this.swiper.slideTo(2, 0);

    },
    methods: {
      animSlider() {
        let _this = this;
        if (this.swiper.activeIndex != 2) {
            this.swiper.slides.eq(2).find('.slider_inner').css('width', 0);
        } else if (this.swiper.previousIndex != 2) {
            let width = 0;
            if(_this.index_data.total_pray_cnt <= 3999) {
              width = (_this.index_data.total_pray_cnt * 102 / 3999) * (window.innerWidth/750) + 'px';
            } else if (_this.index_data.total_pray_cnt <= 6999) {
              width = (102 + (_this.index_data.total_pray_cnt - 3999) * (281-102) / 3000) * (window.innerWidth/750) + 'px';
            } else if (_this.index_data.total_pray_cnt <= 9999) {
              width = (281 + (_this.index_data.total_pray_cnt - 6999) * (469-281) / 3000) * (window.innerWidth/750) + 'px';
            } else if (_this.index_data.total_pray_cnt <= 12999) {
              width = (469 + (_this.index_data.total_pray_cnt - 9999) * (619-469) / 3000) * (window.innerWidth/750) + 'px';
            } else if (_this.index_data.total_pray_cnt > 12999) {
              width = '100%';
            } else {
              width = '0';
            }
            this.swiper.slides.eq(2).find('.slider_inner').css('width', width);
        }
      },
      initData() {
        let _this = this;
        requirejs(['login/index'],gLogin => {
            window.glogin = new gLogin({
                type:'popup',
                //设置 去注册按钮
                login_type: 25,
                fastreg:{
                    //注意：不支持回调函数
                    game:'zt2m',
                    type: 'normal'
                },
                onLogin: function(result, fromeCookie) {
                    if(fromeCookie) {
                        if (!_this.user_info.ga_account && _this.needToRequestUserInfo) {
                            _this.getInfo();
                        }
                    }
                    if(!!result&&!!result.account){
                        //登录成功
                        if (!_this.user_info.ga_account && _this.needToRequestUserInfo) {
                            _this.getInfo().then(() => {
                              if(_this.callBackFn) {
                                _this[_this.callBackFn]();
                              }
                            });
                        }
                    } else{
                        //登录失败
                        // store.commit(types.SHOW_MODAL, {name: 'alert', msg: result.msg, commet: ''});
                    }
                },
                onLogout:function() {

                }
            });
        });
      },
      updateMiniCards() {
        this.cardList = [];
        if(this.user_info.card_id_list && this.user_info.card_id_list.length) {
          this.user_info.card_id_list.forEach(item => {
            this.cardList.push(item);
          });
        }
        if(this.index_data.pray_list && this.index_data.pray_list.length) {
          this.index_data.pray_list.forEach(item => {
            if(this.cardList.length < 11) {
              this.cardList.push(item);
            }
          });
        }
      },
      getInfo() {
          this.needToRequestUserInfo = false;
          return new Promise((resolve, reject) => {
              api.getInfo().then(res => {
                if(res) {
                    if(res.data.act_cfg && res.data.act_cfg.act_status == 0) {
                      store.commit(types.SHOW_ALERT, {msg: res.data.cfg.act_msg});
                    } else {
                      this.user_info = Object.assign({}, res.data.user_info);
                      this.index_data = Object.assign({}, res.data.index_data);
                      this.updateMiniCards();
                      this.animSlider();
                    }
                }
                this.needToRequestUserInfo = true;
                resolve();
              }).catch((err) => {
                this.needToRequestUserInfo = true;
                reject(err);
              });
          });
      },
      showRule() {
        store.commit(types.SHOW_MODAL, {type: 'rule'});
      },
      showRecord() {
        if (!this.user_info.ga_account) {
          this.callBackFn = 'showRecord';
          window.glogin.login();
          return;
        }
        store.commit(types.SHOW_MODAL, {type: 'record', card_id_list: this.user_info.card_id_list});
      },
      showCode() {
        if (!this.user_info.ga_account) {
          this.callBackFn = 'showCode';
          window.glogin.login();
          return;
        }
        if(this.user_info.code_str) {
          store.commit(types.SHOW_MODAL, {type: 'code', code: this.user_info.code_str});
          return;
        }
        store.commit(types.SHOW_LOADING, true);
        api.getPrize().then(res => {
          if(res) {
            store.commit(types.SHOW_MODAL, {type: 'code', code: res.code});
            this.user_info.code_str = res.code;
          }
        });
      },
      showCard() {
        if (!this.user_info.ga_account) {
          this.callBackFn = 'showCard';
          window.glogin.login();
          return;
        }
        if(parseInt(this.user_info.left_cnt) <= 0) {
          store.commit(types.SHOW_ALERT, {msg: '您的祈愿次数已用完~'});
          return;
        }
        store.commit(types.SHOW_LOADING, true);
        api.pray().then(res => {
          if(res && res.card_id) {
            this.user_info.card_id_list.push(res.card_id);
            this.updateMiniCards();
            this.user_info = Object.assign({}, this.user_info, {left_cnt: parseInt(this.user_info.left_cnt) - 1});
            // this.index_data = Object.assign({}, this.index_data, {total_pray_cnt: parseInt(this.index_data.total_pray_cnt) + 1});
            store.commit(types.SHOW_MODAL, {type: 'card', card_id: res.card_id, share: true});
          }
        });
      },
      initAnimation(slide, selector, className, index, activeIndex, previousIndex) {
          if (activeIndex != index) {
              if (!slide.find(selector).hasClass('hide')) {
                  slide.find(selector).addClass('hide');
              }
              slide.find(selector).removeClass(className);
          } else if (previousIndex != index) {
              slide.find(selector).removeClass('hide');
              slide.find(selector).addClass(className);
          }
      },
      slideNext() {
        this.swiper.slideNext();
      },
      changeAccount() {
        glogin.logout();
        this.user_info = Object.assign({}, {});
        this.index_data = Object.assign({}, {});
        glogin.login();
      }
    },
    watch: {
      'goToLogin': function(val) {
        if (val) {
          this.initData();
        }
      }
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../../assets/stylus/minixs/_center.styl';
    .pg-index
        width: 100%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        .hide
            display: none

        .show
            display: block !important;

        .indicator
            position: absolute;
            width: 0.84rem;
            height: 1.41rem;
            left: 3.33rem;
            bottom: 0.3rem;
            background-image: url('./images/mHome/indicator.png');
            background-size: contain;
            background-repeat: no-repeat;
            z-index: 1;
            animation: down 1.5s infinite ease;
            &-1
              background-image: url('./images/m1/indicator1.png');

        .swiper-container
            width: 100%;
            height: 100%;
            margin-left: auto;
            margin-right: auto;

        .swiper-slide-big
            text-align: left;
            background-image: url('./images/m1/bg.jpg');
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            display: flex;
            justify-content: center;
            align-items: center;
            &-home
                background-image: url('./images/mHome/m_bg.jpg');
            &-2
                background-color #fff
                background-image: url('./images/m2/bg.jpg');
                background-position: left top;
                background-size: 100% 10.34rem;
            .emphasis
                color #ffde00
            .content
                height: 100%;
                width: 100%;
                color: black;
                position: relative;

                &_home
                    .header
                        position: fixed;
                        top: 0;
                        height: 1.28rem;
                        background: rgba(0, 0, 0, 0.8);
                        width: 100%;
                        img
                            height 1.04rem
                            float: left;
                            margin: 0.10rem 0 0 0.20rem;
                        .main_title
                            position absolute
                            top 0.28rem
                            left 1.39rem
                            font-size: 0.30rem;
                            color: #fff;
                            .sub_title
                                display: block;
                                margin: 0.05rem 0 0 0;
                                font-size: 0.19rem;
                        .btnsom
                            float: right;
                            margin: 0.40rem 0.30rem 0 0;
                            width: 1.50rem;
                            height: 0.50rem;
                            background: #b48e52;
                            border-radius: 0.10rem;
                            text-align: center;
                            line-height: 0.48rem;
                            color: #fff;
                            font-size: 0.26rem;
                            text-shadow: 0.01rem 0.01rem 0.01rem #00000073;
                            text-decoration none

                    .slogan
                        position: absolute;
                        width: 3.45rem;
                        height: 5.81rem;
                        left: 0.78rem;
                        top: 2.01rem;
                        background: url('./images/mHome/slogan.png') no-repeat;
                        background-size: contain;
                        animation-delay: 0.2s;

                    .human
                        position: absolute;
                        width: 7.5rem;
                        height: 6.77rem;
                        left: 0;
                        bottom: 0;
                        background: url('./images/mHome/human.png') no-repeat;
                        background-size: contain;
                        animation-delay: 0.9s;
                        cursor: pointer;

                &_1
                    font-size: 0.22rem;
                    color: rgb(255, 255, 255);
                    line-height: 0.3rem;
                    .title
                        position: absolute;
                        width: 3.71rem;
                        height: 1.22rem;
                        left: 1.91rem;
                        top: 0.81rem;
                        background-image: url('./images/m1/m_1_title.png');
                        background-size: contain;
                        background-repeat: no-repeat;
                    .moon
                        position absolute
                        width: 3.52rem;
                        height: 2.17rem;
                        background-image: url('./images/m1/moon.png');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        opacity 0

                    .feature_container
                        height 9.02rem;
                        width 100%;
                        position absolute
                        top 50%
                        left 0
                        margin-top -4.51rem;

                    .feature_5
                        position: absolute;
                        width: 6.68rem;
                        height: 2.16rem;
                        left: 0.32rem;
                        // top: 2.49rem;
                        top 18.7%
                        background-image: url('./images/m1/5.png');
                        background-size: 3.14rem 2.16rem;
                        background-repeat no-repeat
                        background-position: left top;
                        padding-left: 1.36rem;
                        padding-top: 0.78rem;
                        animation-delay 4s
                        opacity 0
                    .feature_4
                        position: absolute;
                        width: 6.25rem;
                        height: 2.16rem;
                        left: 0;
                        // top: 4.15rem;
                        // top 1.66rem
                        top 31.1%
                        background-image: url('./images/m1/4.png');
                        background-size: 3.59rem 2.16rem;
                        background-repeat no-repeat
                        background-position: right top;
                        text-align right
                        padding-right: 1.82rem;
                        padding-top: 0.95rem;
                        animation-delay 3s
                        opacity 0
                    .feature_3
                        position: absolute;
                        width: 6.97rem;
                        height: 2.16rem;
                        left: 0.02rem;
                        // top: 5.89rem;
                        top 44.15%;
                        background-image: url('./images/m1/3.png');
                        background-size: 3.14rem 2.16rem;
                        background-repeat no-repeat
                        background-position: left top;
                        padding-left: 1.37rem;
                        padding-top: 0.86rem;
                        animation-delay 2s
                        opacity 0
                    .feature_2
                        position: absolute;
                        width: 7.16rem;
                        height: 2.16rem;
                        left: 0rem;
                        // top: 7.43rem;
                        top 55.7%;
                        background-image: url('./images/m1/2.png');
                        background-size: 3.67rem 2.16rem;
                        background-repeat no-repeat
                        background-position: right top;
                        padding-right: 1.9rem;
                        padding-top: 1.02rem;
                        text-align right
                        animation-delay 1s
                        opacity 0
                    .feature_1
                        position: absolute;
                        width: 6.01rem;
                        height: 2.16rem;
                        left: 0.85rem;
                        // top: 9.35rem;
                        top 70.1%
                        background-image: url('./images/m1/1.png');
                        background-size: 3.16rem 2.16rem;
                        background-repeat no-repeat
                        background-position: left top;
                        padding-left: 1.37rem;
                        padding-top: 0.92rem;
                        opacity 0

                &_2
                    overflow hidden
                    .btns
                        position: absolute;
                        height: 0.80rem;
                        left: 6.20rem;
                        top: 0.44rem;
                        font-size: 0.24rem;
                        color: #94d6ff;
                        line-height: 0.3rem;
                        .btn
                          color: #94d6ff;
                          height 0.32rem;
                          border-bottom 0.02rem solid #94d6ff;
                          margin-bottom 0.2rem
                    .title
                        z-index 1
                        position: absolute;
                        width: 3.71rem;
                        height: 1.2rem;
                        left: 1.91rem;
                        // top: 0.93rem;
                        top 3%
                        background-image: url('./images/m2/m_2_title.png');
                        background-size: contain;
                        background-repeat: no-repeat;
                    .center
                        position: absolute;
                        width: 100%;
                        height: 7.59rem;
                        left: 0;
                        // bottom: 3.7rem;
                        // top 2.05rem
                        top 50%
                        margin-top -5.62rem
                        z-index 1
                        &_1
                            position: absolute;
                            width: 7.24rem;
                            height: 6.02rem;
                            left: 0.02rem;
                            top: 0rem;
                            background-image: url('./images/m2/tree.png');
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                            .card
                                width: 0.66rem;
                                height: 1.61rem;
                                position absolute;
                                background-image: url('./images/m2/card-frame-mini.png');
                                background-size: 100% 100%;
                                background-repeat: no-repeat;
                                padding 0.31rem 0 0.71rem 0.18rem;
                                display flex
                                justify-content center
                                align-items center
                                &_inner
                                  background-size: 100% 100%;
                                  background-repeat: no-repeat;
                                  &_1
                                    width 0.41rem;
                                    height 0.40rem;
                                    background-image: url('./images/m2/card/1.png');
                                  &_2
                                    width 0.44rem;
                                    height 0.44rem;
                                    background-image: url('./images/m2/card/2.png');
                                  &_3
                                    width 0.40rem;
                                    height 0.37rem;
                                    background-image: url('./images/m2/card/3.png');
                                  &_4
                                    width 0.41rem;
                                    height 0.42rem;
                                    background-image: url('./images/m2/card/4.png');
                                  &_5
                                    width 0.40rem;
                                    height 0.39rem;
                                    background-image: url('./images/m2/card/5.png');
                                  &_6
                                    width 0.41rem;
                                    height 0.41rem;
                                    background-image: url('./images/m2/card/6.png');
                                  &_7
                                    width 0.45rem;
                                    height 0.48rem;
                                    background-image: url('./images/m2/card/7.png');
                                  &_8
                                    width 0.42rem;
                                    height 0.42rem;
                                    background-image: url('./images/m2/card/8.png');
                                  &_9
                                    width 0.35rem;
                                    height 0.44rem;
                                    background-image: url('./images/m2/card/9.png');
                                  &_10
                                    width 0.37rem;
                                    height 0.43rem;
                                    background-image: url('./images/m2/card/10.png');
                                  &_11
                                    width 0.37rem;
                                    height 0.37rem;
                                    background-image: url('./images/m2/card/11.png');
                                  &_12
                                    width 0.39rem;
                                    height 0.40rem;
                                    background-image: url('./images/m2/card/12.png');
                                  &_13
                                    width 0.37rem;
                                    height 0.46rem;
                                    background-image: url('./images/m2/card/13.png');
                                  &_14
                                    width 0.37rem;
                                    height 0.42rem;
                                    background-image: url('./images/m2/card/14.png');
                                  &_15
                                    width 0.43rem;
                                    height 0.40rem;
                                    background-image: url('./images/m2/card/15.png');
                                  &_16
                                    width 0.39rem;
                                    height 0.44rem;
                                    background-image: url('./images/m2/card/16.png');
                                  &_17
                                    width 0.41rem;
                                    height 0.38rem;
                                    background-image: url('./images/m2/card/17.png');
                                  &_18
                                    width 0.45rem;
                                    height 0.40rem;
                                    background-image: url('./images/m2/card/18.png');
                                  &_19
                                    width 0.39rem;
                                    height 0.45rem;
                                    background-image: url('./images/m2/card/19.png');
                                  &_20
                                    width 0.41rem;
                                    height 0.42rem;
                                    background-image: url('./images/m2/card/20.png');
                                &_5
                                  top 0.21rem;
                                  left 3.97rem;
                                  opacity 0
                                  animation-delay 1.2s;
                                &_6
                                  top 0.58rem;
                                  left 1.97rem;
                                  animation-delay 1.5s;
                                  opacity 0
                                &_7
                                  top 0.90rem;
                                  left 3.11rem;
                                  animation-delay 1.8s;
                                  opacity 0
                                &_4
                                  top 1.71rem;
                                  left 0.94rem;
                                  animation-delay 0.9s;
                                  opacity 0
                                &_1
                                  top 2.08rem;
                                  left 1.99rem;
                                  opacity 0
                                &_2
                                  top 2.18rem;
                                  left 3.25rem;
                                  animation-delay 0.3s;
                                  opacity 0
                                &_3
                                  top 1.16rem;
                                  left 4.49rem;
                                  animation-delay 0.6s;
                                  opacity 0
                                &_8
                                  top 2.95rem;
                                  left 2.44rem;
                                  animation-delay 2.1s;
                                  opacity 0
                                &_9
                                  top 2.99rem;
                                  left 3.94rem;
                                  animation-delay 2.4s;
                                  opacity 0
                                &_10
                                  top 2.42rem;
                                  left 4.68rem;
                                  animation-delay 2.7s;
                                  opacity 0
                                &_11
                                  top 1.67rem;
                                  left 5.61rem;
                                  animation-delay 3.0s;
                                  opacity 0
                        &_2
                            position: absolute;
                            width: 6.82rem;
                            height: 2.36rem;
                            left: 0.33rem;
                            top: 5.23rem;
                            background-image: url('./images/m2/center_cloud.png');
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                        &_3
                            position: absolute;
                            width: 100%;
                            height: 2.21rem;
                            left: 0rem;
                            top: 3.64rem;
                            background-image: url('./images/m2/top_cloud.png');
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                        &_4
                            position: absolute;
                            width: 6.99rem;
                            height: 1.24rem;
                            left: 0.25rem;
                            top: 2.66rem;
                            background-image: url('./images/m2/twinkle.png');
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                        &_5
                            position: absolute;
                            width: 100%;
                            height: 2.21rem;
                            left: 0rem;
                            top: 5.25rem;
                            background-image: url('./images/m2/bottom_cloud.png');
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                    .bottom
                        position: absolute;
                        width: 100%;
                        height: 5.44rem;
                        left: 0px;
                        top 50%
                        margin-top 0.23rem
                        background-image: url('./images/m2/bottom.png');
                        background-size: 100% 100%;
                        z-index 1
                    .pray_container
                        position: absolute;
                        width: 2.81rem;
                        height: 1.62rem;
                        left: 2.35rem;
                        z-index 1
                        // top: 7.17rem;
                        top 50%
                        margin-top -0.5rem
                        display flex
                        flex-direction column
                        justify-content center
                        align-items center
                        .pray
                            width: 2.81rem;
                            height: 0.96rem;
                            background-image: url('./images/m2/pray.png');
                            background-size: 100% 100%;
                        .times
                            font-size: 0.20rem;
                            color: rgb(255, 255, 255);
                            line-height: 2;
                        .account
                            font-size: 0.20rem;
                            color: rgb(255, 255, 255);
                            line-height: 0.32rem;
                            display flex
                            .name
                                max-width 1.6rem;
                                margin-right 0.12rem;
                                overflow: hidden;
                                text-overflow:ellipsis;
                                white-space: nowrap;
                            .text_btn
                                text-decoration underline

                    .pray_times
                        position: absolute;
                        height: 0.37rem;
                        left: 2.06rem;
                        top: 50%
                        margin-top: 1.85rem;
                        font-size: 0.40rem;
                        color: rgb(51, 51, 51);
                        line-height: 1;
                        z-index 1
                    .gift_wrapper
                        z-index 1
                        display flex;
                        // width 5.13rem;
                        width 5.55rem;
                        height 1.48rem;
                        position absolute
                        left 0.975rem;
                        top 50%
                        margin-top: 2.6rem;
                        .gift_container
                            width: 1.85rem;
                            height: 1.48rem;
                            text-align center
                            font-size: 0.22rem;
                            color: rgb(51, 51, 51);
                            line-height: 1;
                            .gift
                                width 1.18rem;
                                height 1.18rem;
                                border 0.02rem solid #7890be;
                                border-radius 50%
                                margin-left 0.335rem;
                                margin-bottom 0.08rem;
                                padding 0.03rem;
                                &_bg
                                    background #98a5cd;
                                    width: 100%
                                    height: 100%
                                    border-radius 50%
                                    background-image url('./images/m2/gift1.png');
                                    background-size 100% 100%
                                    &_2
                                      background-image url('./images/m2/gift2.png');
                                    &_3
                                      background-image url('./images/m2/gift3.png');
                    .draw
                        z-index 1
                        position: absolute;
                        width: 1.56rem;
                        height: 0.5rem;
                        left: 2.98rem;
                        top 50%
                        margin-top 4.93rem
                        // top: 12.6rem;
                        background-image: -webkit-linear-gradient( 117deg, rgb(53,148,255) 0%, rgb(45,81,147) 100%);
                        border-radius 0.25rem
                        line-height 0.5rem
                        font-size: 0.26rem;
                        text-align center
                        color: rgb(255, 255, 255);
                    .moon
                        position: absolute;
                        width: 1.55rem;
                        height: 1.55rem;
                        left: 4.92rem;
                        top: 50%
                        margin-top -5.17rem;
                        background-image: url('./images/m2/moon.png');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        z-index 0
                    .slider_wrapper
                        z-index 1
                        position: absolute;
                        width: 6.25rem;
                        height: 0.56rem;
                        left: 0.86rem;
                        top: 50%;
                        margin-top: 4.22rem
                        font-size: 0.24rem;
                        color: rgb(51, 51, 51);
                        line-height 1
                        .slider
                            width: 6.25rem;
                            height: 0.24rem;
                            border-style: solid;
                            border-width: 0.03rem;
                            border-color: rgb(134, 161, 241);
                            border-radius 0.12rem;
                            opacity: 0.8;
                            margin-bottom 0.08rem;
                            &_inner
                                width: 0
                                height: 100%;
                                border-radius 0.09rem;
                                // border-bottom-left-radius 0.09rem;
                                background-image: -webkit-linear-gradient( 0deg, rgb(255,54,0), rgb(255,219,0));
                                box-shadow: inset 0px 0.02rem 0.09rem 0px rgba(255, 150, 65, 0.004);
                                transition: width 2s ease-in-out
                            .milestone
                                position: absolute;
                                width: 0.16rem;
                                height: 0.16rem;
                                top: 0.03rem;
                                background #fcedad
                                border-radius 50%
                                padding 0.04rem;
                                &_1
                                    left: 1.02rem;
                                &_2
                                    left: 2.81rem;
                                &_3
                                    left: 4.69rem;
                                &_inner
                                    width: 0.08rem;
                                    height: 0.08rem;
                                    background #ca4a39
                                    border-radius 50%
                        .text_1
                            position absolute
                            left: .83rem;
                            top: .36rem;
                        .text_2
                            position absolute
                            left: 2.64rem;
                            top: .36rem;
                        .text_3
                            position absolute
                            left: 4.5rem;
                            top: .36rem;


        .slideInLeftNew
            animation-name: slideInLeftNew;

        .slideInRightNew
            animation-name: slideInRightNew;

        .moon_ani
            animation: moon 1s ease-in-out forwards;
        .moon_up
            animation: moonUp 1s ease-in-out forwards;

        @media screen and (max-height: 1733px)
            .center
                margin-top -4.82rem !important;

            .content_2
                .title
                    top 0.2rem !important
                .moon
                    left: 4.72rem !important;
                    margin-top -4.97rem !important;

            .pray_container
                margin-top -0.4rem !important

        @keyframes moon
            from
                transform: translate3d(-100%, -100%, 0);
                opacity: 0;
            to
                transform: translateZ(0);
                opacity: 1;
        @keyframes moonUp
            from
                transform: translate3d(-100%, 100%, 0);
                opacity: 0;
            to
                transform: translateZ(0);
                opacity: 1;
        @keyframes slideInRightNew
            from
                transform: translate3d(100%, 0, 0);
                visibility: visible;
            to
                transform: translateZ(0);
                visibility: visible;

        @keyframes slideInLeftNew
            from
                transform: translate3d(-100%, 0, 0);
                visibility: visible;
            to
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                visibility: visible;

        @keyframes down
            0%
                opacity: 0;
                transform: translateY(-0.16rem);
            40%
                opacity: 1;
                transform: translate(0);
            100%
                opacity: 0;
                transform: translateY(0.2rem);

        @keyframes round
            to
                transform: rotate(360deg);

        @keyframes scaleAni
            from
                opacity: 0.8;
                transform: scale3d(0.95, 0.95, 1);

            50%
                opacity: 1;
                transform: scale3d(1.05, 1.05, 1);

            to
                opacity: 0.8;
                transform: scale3d(0.95, 0.95, 1);
</style>
